import { render } from "./personal.vue?vue&type=template&id=08696aaa&scoped=true"
import script from "./personal.vue?vue&type=script&lang=js"
export * from "./personal.vue?vue&type=script&lang=js"

import "./personal.vue?vue&type=style&index=0&id=08696aaa&lang=less&scoped=true"

import exportComponent from "D:\\rwkj\\suershouyyph-mobile\\保安端\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08696aaa"]])

export default __exports__